import React, { memo, useEffect, useRef, useState } from 'react'
import { pick } from 'lodash-es'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import styled from '@emotion/styled'
import { Filters } from '@ow/ditto'
import { IconMaps } from '@ow/icons'
import { useTbViewStore, useFetchRemoteData, useAppEx } from '@vt/hooks'
import useAmap from '../../../../hooks/use-amap/use-marks'

const StyledExpandBtn = styled.div`
  cursor: pointer;
  height: 36px;
  span {
    font-size: var(--font-size-sm);
    color: var(--ow-color-primary-700);
  }
  ${tw`flex items-center`}
`

const ExportMap = ({ showTbDetail }) => {
  const { setMapRef } = useTbViewStore((state) => pick(state, ['setMapRef']))
  const [isExpand, setIsExpand] = useState(false)

  const { fields, fixedFilters, setFilters, filters } = useTbViewStore(
    (state) =>
      pick(state, [
        'viewType',
        'fields',
        'fixedFilters',
        'setFilters',
        'filters',
      ])
  )

  const { tbs } = useAppEx()

  const fetchRemoteData = useFetchRemoteData()

  const ref = useRef()
  useAmap('export-map', {
    showTbDetail,
  })

  useEffect(() => {
    setMapRef(ref)
    setFilters(
      {
        ...filters,
        queries: [
          ...filters.queries,
          {
            slug: 'createdAt',
            value: {
              startDate: new Date(dayjs().startOf('month')),
              endDate: new Date(dayjs().endOf('month')),
            },
            queryType: 'dayRange',
            fixed: true,
          },
        ],
      },
      null,
      false
    )
  }, [])

  if (!fixedFilters) {
    return null
  }

  return (
    <div className="w-full h-full relative">
      <div
        ref={ref}
        id="export-map"
        className="w-full"
        style={{ minHeight: `${window.innerHeight}px` }}
      />

      <div className="absolute top-0 left-0" style={{ background: '#fff' }}>
        <StyledExpandBtn
          onClick={() => {
            setIsExpand(!isExpand)
          }}
          className="expand-btn"
        >
          <span>{isExpand ? '收起筛选' : '展开筛选'}</span>
          <div style={{ transform: `${isExpand ? 'rotate(180deg)' : ''}` }}>
            <IconMaps
              type="expandIcon"
              width={16}
              height={16}
              fill="var(--ow-color-primary-700)"
            />
          </div>
        </StyledExpandBtn>
        {isExpand && (
          <div style={{ background: '#fff' }}>
            <Filters
              tbs={tbs}
              defaultValue={filters}
              fixedFilters={fixedFilters}
              fields={fields}
              showSearch={true}
              onFetchRemoteData={fetchRemoteData}
              onChange={(a, b, c) => {
                console.log(a, b, '哈哈哈哈哈')
                setFilters(a, b, false)
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(ExportMap)
